import { formatDuration } from '../../utils/formatDuration';

/**
 * SF-122: one in-flight army line, used in the Armies Away card. `formatDuration()`'s real,
 * only full-precision consumer (Component 5) — full days + real hours/minutes, not day-only.
 *
 * Deviation note: the spec's Application Interface table lists `label`/`ticksRemaining`/
 * `returnTimeFraction`/`unitsSummary` as this component's props, but Component 5's own worked
 * example (`formatDuration(army.ticksRemaining, { returnTimeFraction: army.returnTimeFraction,
 * tickIntervalMs: province.sync.tickIntervalMs, includeMinutes: true })`) requires
 * `tickIntervalMs` to actually compute a duration — the prop table omitted it. `tickIntervalMs`
 * is added here as a required prop so the component is actually implementable; callers pass
 * `province.sync.tickIntervalMs`.
 */
interface ArmyRowProps {
  label: string;
  ticksRemaining: number;
  returnTimeFraction: number;
  tickIntervalMs: number;
  unitsSummary?: string;
}

export function ArmyRow({ label, ticksRemaining, returnTimeFraction, tickIntervalMs, unitsSummary }: ArmyRowProps) {
  const duration = formatDuration(ticksRemaining, {
    returnTimeFraction,
    tickIntervalMs,
    includeMinutes: true,
  });

  return (
    <div className="flex items-center justify-between">
      <div className="min-w-0">
        <div className="text-sm text-game-200">{label}</div>
        {unitsSummary && <div className="text-xs text-game-400">{unitsSummary}</div>}
      </div>
      <span className="text-xs font-mono flex-shrink-0" style={{ color: '#ff8844' }}>
        {duration}
      </span>
    </div>
  );
}
